module.exports = __webpack_public_path__ + "img/report-sample-07@3x.63200b69.png";